import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router} from '@angular/router';
import { ClientService } from '../services/client.service';
import { ToastrService } from 'ngx-toastr';
import { Client } from '../models/clientLocation';
import { PhonePipe } from '../../pipes/phone.pipe';
import { Subject} from 'rxjs';
import { ScreeningService } from '../../screening-module/services/screening.service';
import * as _ from 'lodash';
import { ClientFilter } from '../models/ClientFilter';
import { FilterDataType, SimpleDataFilter } from '../../models/simpleDataFilter';
import { FilteringService } from 'src/app/services/filtering.service';
import { PaginationEventData } from 'src/app/shared-components-module/pagination-top/models/paginationEventData';

@Component({
  selector: "app-clients",
  templateUrl: "./clients.component.html",
  styleUrls: ["./clients.component.less"]
})
export class ClientsComponent implements OnInit, AfterViewInit, OnDestroy {
  currentPage: number = 0;
  pageIncrement: number = 30;
  ngOnDestroy(): void {
   try {
    this.filtering.filters = [];
    this.clients.clients = [];
   } catch (error) {
   }
  }

  loaded:boolean = false;
  clearFiltersFunc : Subject<any> = new Subject<any>();
  displayFilters : boolean = true;
  pageIncrements : any[] = ['10', '30', '50', '100', '200'];
  constructor(public phone : PhonePipe,
    public auth : AuthService,
    private location : Router,
    public clients : ClientService,
    public toast : ToastrService,
    public filtering :FilteringService,
    public screening : ScreeningService){
    // fetch the clients for this user.
    this.clients.editMode = false;
  }

  public get filteredClients(): Array<Client> {
    if(!this.clients.clients) return [];
    return this.clients.clients;
  }

  ngAfterViewInit(): void {
    document.getElementById('filterPanel').addEventListener("keypress", e => {
      if (e.key == "Enter") this.applyFilters();
    });
  }

  public editClient(cnt: Client) {
    this.location.navigateByUrl(
      `clients/review/${cnt.id}`
    );
  }


  addClient() {
    this.navigate("/clients/new");
  }

  clearFilters() {
    this.clients.clientFilter = new ClientFilter();
    this.filtering.filters = [];
    this.clients.clients = [];
    this.clients.FetchClientList(this.clients.clientFilter);
  }

  showFilters() {
    this.displayFilters = !this.displayFilters;
  }

  public onPaginationChanged(event : PaginationEventData) {
    this.clients.clients = [];
    this.clients.FetchClientList(this.clients.clientFilter);
    this.filtering.clearTransientFilters();
  }

  ngOnInit() {
    this.clients.FetchClientList(this.clients.clientFilter);
  }

  navigate(path: string) {
    this.location.navigateByUrl(path);
  }

  applyFilters(): void {
    this.clients.clients = [];
    this.clients.FetchClientList(this.clients.clientFilter);
    this.currentPage = 0;
  }

  //specifically for the date pickers:
  update(val: any) {
    this.clients.clientFilter[val.property] = val.time;
  }
}
